import { render, staticRenderFns } from "./ApplyAssetCard.vue?vue&type=template&id=70cf5a15&"
import script from "./ApplyAssetCard.vue?vue&type=script&lang=js&"
export * from "./ApplyAssetCard.vue?vue&type=script&lang=js&"
import style0 from "./ApplyAssetCard.vue?vue&type=style&index=0&id=70cf5a15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports